








































































































































































































































































































































































// import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  viewInfo, CruiseEventData, emptyCruiseEvent
} from '@/api/heritageCruise/cruiseEvent'
//import ViewLink from '@/components/viewLink.vue'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import hspGallery from '@/components/upload/gallery.vue'
import UnitMap from '@/components/unitMap/index.vue'
import { CruiseTrackDetailData } from '@/api/heritageCruise/cruiseTrack'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import EventGradeForm from './grade.vue'
import { UnitPositionMapData, CheckPointData } from '@/api/common/mapData'

@Component({
  components: { hspGallery, UnitMap, ViewDialog, EventGradeForm }
})
export default class CruiseEventView extends Vue {
  public showDialog: boolean = false
  public loading: boolean = false
  public tabName: string = 'tabEvent'
  public showGrade: boolean = false

  public hasCallback: boolean = false
  public form: CruiseEventData = emptyCruiseEvent
  public $refs!: {
    refUnitMap: UnitMap
    gradeCtrl: EventGradeForm
  }
  public hasFile: boolean = true
  public onFileChange(data: { opts: UploadOptData; files: AttachInfo[] }) {
    const list = data.files
    this.hasFile = list.length > 0
  }
  public created() { }
  public mounted() {
    window.eventBus.$on('viewCruiseEvent', (id: number) => {
      this.showDialog = true
      this.showGrade = false
      this.tabName = 'tabEvent'
      this.fetchData(id)
    })
    window.eventBus.$on('openEventGrade', (id: number) => {
      this.showDialog = true
      this.showGrade = true
      this.tabName = 'tabGrade'
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewCruiseEvent')
    window.eventBus.$off('openEventGrade')
  }
  public gradeSubmit(info: any) {
    if (info == null) {
      this.closeDialog()
    }
    this.tabName = 'tabAction'
    this.showGrade = false
    this.hasCallback = true
    this.fetchData(info.EventId)
  }
  public closeDialog() {
    if (this.$refs.refUnitMap) {
      this.$refs.refUnitMap.closeMap()
    }
    this.showDialog = false
    if (this.hasCallback) {
      window.eventBus.$emit('viewCruiseEvent_Callback')
    }
  }
  public tabClick(tab: any, event: any) {
    let tabType = tab.name
    if (tabType == 'tabMap') {
      this.loadMap()
    }
  }
  public loadMap() {
    const f = this.form
    const mapData: {
      checkPoint: CheckPointData
      positions: UnitPositionMapData[]
      tracks: CruiseTrackDetailData[]
      obj: any
    } = {
      checkPoint: {
        pointId: f.CruisePointId,
        pointName: f.CruisePointName,
        lng: f.CruisePointLongitude,
        lat: f.CruisePointLatitude
      },
      positions: this.form.UnitPositionAreas,
      tracks: [],
      obj: { unitName: f.UnitName }
    }
    if (this.$refs.refUnitMap) {
      this.$refs.refUnitMap.loadData(mapData)
    }
    // window.eventBus.$emit('loadUnitMap', mapData)
  }
  public fetchData(id: number) {
    this.loading = true
    viewInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        if (this.showGrade) {
          const actions = this.form.ActionList.filter(
            (v: any) => v.ActionType == 8
          )
          this.$nextTick(() => {
            this.$refs.gradeCtrl.loadData({
              id: id, actions: actions
            })
          })
        }
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
}
